module.exports = __webpack_public_path__ + "img/ingredients_d_origine_naturelle.f42f022.svg";